export default __webpack_public_path__ + "static/media/angle.b1c7ff25.svg";